import { useUser } from './useUser'
import { useState, useEffect } from 'react'

export const useAuthGuard = () => {
  const { isLoggedIn, name } = useUser()
  const [loginPrompt, setLoginPrompt] = useState(null)

  // Close popup when user becomes authenticated
  useEffect(() => {
    if (isLoggedIn) setLoginPrompt(null)
  }, [isLoggedIn])

  const requireAuth = (feature) => {
    if (isLoggedIn) return true
    setLoginPrompt(feature)
    return false
  }

  return {
    isAuthenticated: isLoggedIn,
    requireAuth,
    loginPrompt,
    closePrompt: () => setLoginPrompt(null),
    user: { name }
  }
}
